<template>
  <div class="class-management">
            <!-- <el-cascader v-model="" :options="options" :props="props" collapse-tags clearable></el-cascader> -->
    <TableLayout>
      <template slot="search-form">
        <section class="btn-actions">
          <div class="fl">
            <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="86px" inline>
              <el-form-item prop="type">
                <el-select @change="search()" style="width:160px; marginLeft: 13px" v-model="searchForm.gradeType" placeholder="请选择" size="small">
                  <el-option v-for="item in classTypeOptions" :key="`type_${item.value}`" :label="item.label" :value="item.value" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item  prop="major">
                <el-select @change="search()" style="width:160px; marginLeft: 13px" v-model="searchForm.professionId" placeholder="请选择专业名称" clearable size="small" >
                  <el-option v-for="item in majorNameOptions" :key="item.id" :label="item.dictionaryName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级名称" prop="class">
                <el-input v-model="searchForm.gradeName" placeholder="请输入" @keyup.enter.native="keyDownEnter" clearable size="medium" class="item-width"></el-input>
              </el-form-item>
              <section style="">
                <div class="search-btn" @click="search()" >搜索</div>
                <!-- <el-button size="small" type="primary" @click="search()" >搜索</el-button> -->
              </section>
            </el-form>
          </div>
          <div class="fr">
            <el-button size="small" type="primary" @click="handleCreateClass">创建班级</el-button>
          </div>
        </section>
      </template>
      <!-- 表格和分页 :height="tableHeight - (showObj ? 34 : 0)" -->
      <template slot="table-wrap">
        <el-table ref="tableList" :height="tableHeight" :row-style="selectedstyle" :row-class-name="tableRowClassName"
          :header-cell-style="{background:'#1e87f1', color:'#fff', 'text-align':'center'}"
          v-loading="isWorking.loading" :data="tableData.list"
        >
          <el-table-column label="班级名称" min-width="120px" show-overflow-tooltip align="center">
            <template slot-scope="{ row }"><span>{{ row.levelNum + row.name }}</span></template>
          </el-table-column>
          <el-table-column prop="profressionName" label="专业名称" min-width="180px" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="totalNum" label="班级人数" min-width="150px" align="center"></el-table-column>
          <el-table-column label="创建时间" min-width="200px" align="center">
            <template slot-scope="{ row }"><span>{{ formatDate(row.createTime) }}</span></template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="300px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="handleEditClass(row)">编辑</el-button>
              <el-button type="text" @click="studentDetails(row)">学生详情</el-button>
              <el-button v-if="row.gradeType === 1" type="text" @click="handleConfigCourses(row)">开始课程配置</el-button>
              <el-button v-if="row.totalNum <= 0" type="text" class="delete" @click="handleDeleteClass(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="fix-footer">
          <pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange($event, { msg: true })"
            :pagination="tableData.pagination"
          ></pagination>
        </div> -->
      </template>
    </TableLayout>
    <Dialog :title="dialogTitle" :visible.sync="dialogVisible" @dialog-confirm="dialogHandleConfirm" >
      <el-form ref="dialogForm" :model="dialogForm" label-width="100px" class="class-form" label-position="left">
        <template v-if="dialogType === dialogTypeArr[0] || dialogType === dialogTypeArr[1]">
          <el-form-item label="班级名称" prop="name" :rules="nameRule" class="full-width-row">
              <el-col :span="7">
                <el-select style="width:100%" placeholder="请选择" size="small" v-model="dialogForm.namePrefix" @change="updateFullName">
                  <el-option v-for="item in classNamePrefix" :key="`class-name_${item.value}`" :label="item.label" :value="item.value" ></el-option>
                </el-select>
              </el-col>
              <el-col :span="16" :offset="1">
                <el-input placeholder="请输入班级名称" show-word-limit size="small" maxlength="30"
                  v-model="dialogForm.nameSuffix" @change="updateFullName"></el-input>
              </el-col>
          </el-form-item>
          <el-row>
            <el-col :span="11">
              <el-form-item label="专业名称" prop="major" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-select style="width:100%" placeholder="请选择专业名称" size="small" v-model="dialogForm.major"
                  :disabled="dialogForm.courseChapters && dialogForm.courseChapters.length > 0">
                  <el-option v-for="item in majorNameOptions" :key="item.id" :label="item.dictionaryName" :value="item.id" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item label="结课时间" prop="date" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-date-picker type="date" placeholder="请选择结课日期" style="width:100%" value-format="yyyy-MM-dd" size="small"
                  v-model="dialogForm.date" :picker-options="pickerOptions" :clearable="false"/>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else-if="dialogType === dialogTypeArr[2]">
          <el-form-item label="课程开放时间" prop="courseOpenType" label-width="150px" class="full-width-row-course" :rules="courseOpenRule">
            <el-radio-group style="margin-right: 10px" v-model="dialogForm.courseOpenType">
              <el-radio label="now">现在开放</el-radio>
              <el-radio label="later">定时开放</el-radio>
            </el-radio-group>
            <el-date-picker type="date" placeholder="请选择开放时间" value-format="yyyy-MM-dd" size="small" :clearable="false"
                v-model="dialogForm.courseOpenDate" :picker-options="pickerOptions" :disabled="dialogForm.courseOpenType !== 'later'" />
          </el-form-item>
          <el-form-item label="选择小节" prop="courseChapters" label-width="150px" class="full-width-row-course-unnecessary" size="small">
            <el-cascader v-model="dialogForm.courseChapters" :options="directoryList" :props="cascaderProps"
              :popper-append-to-body="false" popper-class="custom-dropdown" :show-all-levels="false" collapse-tags clearable ></el-cascader>
          </el-form-item>
          <el-form-item label="提交后是否展示答案" prop="courseIsDisplayAnswer" label-width="150px" class="inline-item-course" 
            :rules="{ required: true, message: ' ', trigger: 'blur' }">
            <el-col :span="5">
            <el-switch v-model="dialogForm.courseIsDisplayAnswer" style="margin-left: 0"></el-switch>
            </el-col>
          </el-form-item>
        </template>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import { comMethod } from '@/utils/index.js'
import Pagination from '@/components/common/pagination';
import Dialog from './Dialog';
import BaseTable from '@/components/BaseTable'
import TableLayout from '@/layout/TableLayout'
import { classNamePrefix } from '@/data/data';
import { formatDate } from '@/utils/formatDate.js';
import { classServer, keyServer } from '@/api/api';
export default {
  name: 'ClassManage',
  extends: BaseTable,
  components: { TableLayout, Pagination, Dialog },
  data () {
    return {
      tableHeight: 300,
      classNamePrefix,
      searchForm: {
        gradeType: 0,
        professionId: '',
        gradeName: ''
      },
      classTypeOptions: [ { value: null, label: '全部' }, { value: 0, label: '在教班级' }, { value: 1, label: '结课班级' } ],
      majorNameOptions: [],
      classId: '',
      dialogTypeArr: ['creatClass', 'handleEditClass', 'configCourse'],
      dialogTitle: '创建班级',
      dialogType: 'creatClass',
      dialogVisible: false,
      dialogForm: {
        name: '',
        namePrefix: '',
        nameSuffix: '',
        major: '',
        date: '',
        courseOpenDate: '',
        courseOpenType: '',
        courseChapters: [],
        courseIsDisplayAnswer: false
      },
      nameRule: this.setFormOptions().nameRule,
      courseOpenRule: this.setFormOptions().courseOpenRule,
      pickerOptions: this.setFormOptions().pickerOptions,
      isTeaching: true,
      cascaderProps: {
        "multiple":true,
        "label":"name",
        "value":"id",
        "children":"subList",
        // "checkStrictly":true,
        "emitPath":false
      },
      directoryList: [],
      idNodesMap: new Map()
    }
  },
  created () {
    // this.tableHeight = comMethod.getTableHeight(205);
    this.tableHeight = comMethod.getTableHeight(165);
  },
  mounted () {
    this.getMajorName();
    this.getClassList();
    this.initDialogFormData();
  },
  methods: {
    formatDate,
    initDialogFormData() {
      this.dialogForm = {
        name: '',
        namePrefix: '',
        nameSuffix: '',
        major: '',
        date: this.getDefaultDate(),
        courseOpenType: 'now',
        courseOpenDate: '',
        courseChapters: [],
        courseIsDisplayAnswer: false
      };
    },
    updateFullName() { 
      this.dialogForm.name = `${this.dialogForm.namePrefix}${this.dialogForm.nameSuffix}`;
      this.$refs.dialogForm.validateField('name');
    },
    setFormOptions() {
      return {
        nameRule: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.dialogForm.namePrefix || !this.dialogForm.nameSuffix) {
                callback(new Error(" "));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"]
          }
        ],
        courseOpenRule: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.dialogForm.courseOpenType === 'later' && !this.dialogForm.courseOpenDate) {
                callback(new Error(" "));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"]
          }
        ],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      }
    },
    validateForm(formName) {
      return new Promise( resolve => {
        this.$refs[formName].validate( valid => {
          if (valid) {
            resolve(true);
          } else {
            this.$message.error('请检查必填项');
            resolve(false);
          }
        });
      });
    },
    getDefaultDate() {
      const nextYear = new Date().getFullYear() + 1;
      return `${nextYear}-07-01`;
    },
    // 获取班级数据
    async getClassList() {
      try {
        const res = await classServer.classSearchList({ ...this.searchForm });
        const { code, data, message } = res;
        if (code === '0') {
          this.tableData.list = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    buildIdNodesMap() {
      const idMap = new Map();
      const buildMap = (nodes) => {
        nodes.forEach(node => {
          idMap.set(node.id, node);
          if (node.subList && node.subList.length > 0) {
            buildMap(node.subList);
          }
        });
      }
      buildMap(this.directoryList);
      this.idNodesMap = idMap;
    },
    filterChildIds(targetIds) {
      return targetIds.filter(id => {
        if (this.idNodesMap.has(id)) {
          const node = this.idNodesMap.get(id);
          return node.subList === null;
        }
      });
    },
    handleCreateClass() {
      this.dialogTitle = '创建班级';
      this.dialogType = this.dialogTypeArr[0];
      this.initDialogFormData();
      this.handleOpenDialog();
    },
    async handleEditClass(row) {
      this.classId = row.id;
      const { grade: backendData, directoryList: { selectedIds } } = await this.queryClassById();
      if(!backendData) return;
      this.dialogTitle = '编辑班级';
      this.dialogType = this.dialogTypeArr[1];
      this.initDialogFormData();
      let form = {
        name: backendData.levelNum + backendData.name,
        namePrefix: backendData.levelNum,
        nameSuffix: backendData.name,
        major: backendData.profressionId,
        date: backendData.endTime,
        courseChapters: selectedIds
      };
      this.dialogForm = { ...this.dialogForm, ...form };
      this.handleOpenDialog();
    },
    async handleConfigCourses (row) {
      this.classId = row.id;
      const { grade: backendData, directoryList } = await this.queryClassById();
      this.directoryList = directoryList.directoryList;
      if(!backendData) return;
      this.dialogTitle = '课程配置';
      this.dialogType = this.dialogTypeArr[2];
      this.initDialogFormData();
      let courseChapters = directoryList.selectedIds;
      if(this.directoryList.length > 0){
        this.buildIdNodesMap();
        courseChapters = this.filterChildIds(courseChapters);
      }
      let form = {
        courseOpenType: backendData.startType === 0 ? 'now' : 'later',
        courseOpenDate: backendData.definiteTime || '',
        courseChapters,
        courseIsDisplayAnswer: backendData.showResultType === 1 ? true : false,
      };
      this.dialogForm = { ...this.dialogForm, ...form };
      this.handleOpenDialog();
    },
    async handleDeleteClass(row) {
      this.classId = row.id;
      try {
        await this.$confirm('请确认是否删除该班级？', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      await this.deleteClass();
      } catch (error) { }
    },
    handleOpenDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogForm?.clearValidate();
      });
    },
    studentDetails (row) {
      // this.classId = row.id;
      let rourteUrl = this.$router.resolve({
        path: 'StudentDetails',
        query: { id: row.id }
      });
      window.open(rourteUrl.href, '_blank');
    },
    async dialogHandleConfirm() {
      let valid = await this.validateForm('dialogForm');
      if(!valid) return;
      this.dialogVisible = false;
      switch (this.dialogType) {
        case this.dialogTypeArr[0]:
          await this.createClass();
          break;
        case this.dialogTypeArr[1]:
          await this.editClass();
          break;
        case this.dialogTypeArr[2]:
          await this.configCourses();
          break;
        default:
          break;
      }
    },
    initBackendForm() {
      const profressionName = this.majorNameOptions.find(item => item.id === this.dialogForm.major)?.dictionaryName;
      return {
        name: this.dialogForm.nameSuffix,
        endTime: this.dialogForm.date.slice(0, 10),
        levelNum: this.dialogForm.namePrefix,
        profressionName: profressionName || '',
        profressionId: this.dialogForm.major
      }
    },
    findParentIds(targetIds) {
      const result = new Set();
      const findChildren = (id) => {
        const node = this.idNodesMap.get(id);
        if(!node) return;
        result.add(id);
        if(node.parentId !== null) {
          findChildren(node.parentId);
        }
      }
      targetIds.forEach(id => {
        if(this.idNodesMap.has(id)) {
          findChildren(id);
        }
      });
      return Array.from(result);
    },
    async queryClassById() {
      const res = await classServer.classDetail({ gradeId: this.classId });
      return res.data || null;
    },
    async createClass() {
      const form = this.initBackendForm();
      try {
        const res = await classServer.classAdd({...form});
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getClassList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async editClass() {
      const form = this.initBackendForm();
      try {
        const res = await classServer.classUpdate({...form, id: this.classId });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getClassList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async configCourses() {
      let backendForm = {
        gradeId: this.classId,
        type: this.dialogForm.courseOpenType === 'now' ? 0 : 1,
        definiteTime: this.dialogForm.courseOpenType === 'later' ? this.dialogForm.courseOpenDate : '',
        submiteType: this.dialogForm.courseIsDisplayAnswer ? 1 : 0,
      };
      if(this.dialogForm.courseChapters.length > 0) {
        const directoryIdsArr = this.findParentIds(this.dialogForm.courseChapters);
        backendForm = {
          ...backendForm,
          directoryIds: directoryIdsArr.join(',')
        }
      }
      this.idNodesMap = new Map();
      try {
        const res = await classServer.classCourseConfig({ ...backendForm });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getClassList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async deleteClass() {
      try {
        const res = await classServer.deleteGrade({
          gradeId: this.classId
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getClassList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    // 获取专业数据
    async getMajorName () {
      try {
        const res = await keyServer.profession({
          dictionaryKey: 'profession'
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.majorNameOptions = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },

    handlePageChange (pageIndex, obj = {}) {
      this.getClassList();
      // if (this.searchForm.gradeType === 0) {
      //   this.isTeaching = true;
      // } else {
      //   this.isTeaching = false
      // }
    },
    handleChange(value) {
      // 手动收起下拉框
      this.$nextTick(() => {
        this.$refs.cascader.dropDownVisible = false; // 收起下拉框
      })
    },
    keyDownEnter (e) {
      e.preventDefault(); // 阻止事件默认行为
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 13) {
        this.search();// 搜索按钮的回调
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.class-management .btn-actions {
  .search-btn {
    display: inline-block;
    width: 60px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #D0DFFB;
    color: #0052D9;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 30px;
    margin-left: 2px;
    text-align: center;
    // &:hover {
    //   background: #0052D9;
    //   border: 1px solid #0052D9;
    //   color: #fff;
    // }
  }
  /deep/ .el-input__inner {
    font-family: PingFang SC;
    height: 32px;
    // color: #AAB4D2;
  }
  /deep/ .el-select {
    .el-input__inner {
      width: 160px;
      border-radius: 4px;
      color: #4F6389;
    }
  }
}
.class-management {
  width: 100%;
  height: 100%;
  .class-form {
    width: 90%;
    .radio-group-class {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .full-width-row-course, .full-width-row-course-unnecessary {
      display: flex;
    }
    .class-delete-prompt {
      color: red;
    }
  }
}
</style>

<style lang="scss">
.class-management {
  .el-dialog__body, .my-scroll {
    overflow: auto;
    padding-top: 30px;
  }
  .full-width-row-course {
    .el-form-item__content {
      margin-left: 40px !important;
    }
  }
  .full-width-row-course-unnecessary {
    .el-form-item__label {
      padding-left: 10px;
    }
    .el-form-item__content {
      margin-left: 30px !important;
    }
  }
  .el-input--small .el-input__icon {
    line-height: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/classCenter/classManage.vue